import React from "react";

import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import SensorsIcon from "@mui/icons-material/Sensors";
import { Chip } from "@mui/material";

import { SENSOR_CHIP_SX } from "components/sensors/table/chips/sensor-chip-style";
import { noValueText } from "components/sensors/table/no-value-text";

const PILL_WIDTH = "96px";

export function SensorTypeChip({ sensorType }: { sensorType: string }) {
  if (!sensorType) {
    return noValueText("Unknown");
  }
  const icon =
    sensorType === "Sensor" ? (
      <SensorsIcon fontSize="small" />
    ) : sensorType === "Weather" ? (
      <CloudQueueIcon fontSize="small" />
    ) : undefined;
  return (
    <Chip
      size="small"
      icon={icon}
      label={sensorType}
      sx={{ ...SENSOR_CHIP_SX, width: PILL_WIDTH }}
    />
  );
}
